import type { LabsGqlPatientDto } from '@orthly/graphql-schema';
import dayjs from 'dayjs';

export class PatientDisplayUtils {
    static getPatientName(patient: Pick<LabsGqlPatientDto, 'first_name' | 'last_name'>) {
        return `${patient.first_name} ${patient.last_name}`;
    }

    static getPatientBirthday(patient: Pick<LabsGqlPatientDto, 'birthday'>) {
        return dayjs(patient.birthday).format('M/D/YYYY');
    }

    static getPatientAge(patient: Pick<LabsGqlPatientDto, 'birthday'>) {
        return `${dayjs().diff(dayjs(patient.birthday), 'year')} years old`;
    }

    static getPatientGender(patient: Pick<LabsGqlPatientDto, 'gender'>) {
        return patient.gender;
    }
}
